import React from "react";
import UploadedFileItem from "./UploadedFileItem";

const UploadedFilesList = ({ files, onDelete, formatFileSize , pageLanguage }) => {
  return (
    <div className="upload-files-gridUploadFileNew">
      {files.map((file) => (
        <UploadedFileItem
          key={file.id}
          file={file}
          onDelete={() => onDelete(file.id)}
          formatFileSize={formatFileSize}
          pageLanguage = {pageLanguage}
        />
      ))}
    </div>
  );
};

export default UploadedFilesList;